import { createAction } from './util/createAction'

export const [
  createBooking,
  createBookingSuccess,
  createBookingFailure
] = createAction('BOOKING_CREATE', booking => ({
  booking
}))

export const [setBookingValue] = createAction(
  'BOOKING_SET_VALUE',
  (key, value) => ({
    key,
    value
  })
)

export const [
  fetchKmPrice,
  fetchKmPriceSuccess,
  fetchKmPriceFailure
] = createAction(
  'BOOKING_FETCH_KM_PRICE',
  (endDateUnix) => ({ endDateUnix }),
  (data) => data  // successTransform: Daten durchreichen
)
